import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpBackend, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { StoreModule } from '@ngrx/store';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './common/components/shared.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
//import { reducers } from './common/stores/reducers';
import { LoadingImageModule } from './common/components/loading-image/loading-image.module';
import { OAuth2Service } from './common/services/oauth.service';
import { TokenInterceptorService } from './common/services/token-interceptor.service';
import { SessionService } from './common/services/session.service';
import { FaqChatbotComponent } from './common/faq-chatbot/faq-chatbot.component';

export function createTranslateLoader(httpBackend: HttpBackend) {
    return new TranslateHttpLoader(new HttpClient(httpBackend), './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        FaqChatbotComponent,
    ],
    imports: [
        BrowserModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpBackend]
            }
        }),
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        //StoreModule.forRoot(reducers),
        LoadingImageModule
    ],
    providers: [OAuth2Service, SessionService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
